export const serviceId = process.env.REACT_APP_SERVICE_ID;
export const templateId = process.env.REACT_APP_TEMPLATE_ID;
export const userId = process.env.REACT_APP_USER_ID;